import React from 'react';
import { Paper, Box, Button, Typography, Grid } from '@material-ui/core';
import { Form } from 'react-final-form';
import { uploadTypes } from '../../../../config/constants';
import ImageUploadField from '../ImageUploadField';

const LogosTab = ({ config, onSave }) => {
  const handleSubmit = (values) => {
    onSave({
      ...config,
      logo_small: values.logo_small,
      logo_large: values.logo_large,
    });
  };

  const initialValues = {
    logo_small: config?.logo_small,
    logo_large: config?.logo_large,
  };

  return (
    <Paper>
      <Box p={3}>
        <Typography variant="h6" gutterBottom>
          Logo Settings
        </Typography>
        <Typography variant="body2" color="textSecondary" gutterBottom>
          Two logo sizes are used across different screens. The same logos are displayed on:
          <br />- Splash / Loading screens (Large logo used)
          <br />- Game Rules / Level Selector screens (automatically resized version of the large logo used)
          <br />- Game / Result screens (Small logo used)
        </Typography>

        <Form
          onSubmit={handleSubmit}
          initialValues={initialValues}
          render={({ handleSubmit, submitting }) => (
            <form onSubmit={handleSubmit}>
              <Grid container spacing={3}>
                <Grid item xs={12} md={6}>
                  <ImageUploadField
                    name="logo_large"
                    label="Large Logo (two rows / compact)"
                    uploadType={uploadTypes.wordFinder}
                    helperText="Maximum 128 px height, width is not limited"
                  />
                </Grid>

                <Grid item xs={12} md={6}>
                  <ImageUploadField
                    name="logo_small"
                    label="Small Logo (single line)"
                    uploadType={uploadTypes.wordFinder}
                    helperText="Maximum 50 px height, width is not limited"
                  />
                </Grid>
              </Grid>

              <Box mt={3}>
                <Button type="submit" variant="contained" color="primary" disabled={submitting}>
                  Save Logo Settings
                </Button>
              </Box>
            </form>
          )}
        />
      </Box>
    </Paper>
  );
};

export default LogosTab;
